window.$ = window.jQuery;

$(".tab__trigger").on("click", function(e) {
    e.preventDefault();
    const target = e.currentTarget;
    
    if ($(target).hasClass("tab__trigger--active")) return;
  
    const index = $(target).data("index");
  
    $(".tab__trigger")
      .addClass("tab__trigger--disable")
      .removeClass("tab__trigger--active");
  
    $(target)
      .removeClass("tab__trigger--disable")
      .addClass("tab__trigger--active");
  
    const exitEl = $(target)
      .parents(".tab")
      .find(".tab-inner")
      .not(".tab-inner__disable");
  
    const enterEl = $(target)
      .parents(".tab")
      .find(`.tab-inner[data-index="${index}"]`);
  
    $(exitEl).animate(
      {
        opacity: 0
      },
      300,
      "swing",
      function() {
        $(exitEl).addClass("tab-inner__disable").hide();
        
        $(enterEl)
          .removeClass("tab-inner__disable")
          .css("opacity", 0)
          .show();
        
        $(enterEl).animate(
          {
            opacity: 1
          },
          300,
          "swing"
        );
      }
    );
});
  